import { render, staticRenderFns } from "./AgGridTable.vue?vue&type=template&id=ce04c7fe&scoped=true"
import script from "./AgGridTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AgGridTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AgGridTable.vue?vue&type=style&index=0&id=ce04c7fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce04c7fe",
  null
  
)

export default component.exports